import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadPlatformFormErrorCommandHandler implements IPlatformCommandHandler {

  constructor(private commandService: CommandService,
              private snackbarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService) {

  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.fuseSplashScreenService.show();

    this.commandService.executePlatformCommand(command).subscribe( response => {
      if (response.fieldValues['FileModel']) {
        const downloadResponse = response.fieldValues['FileModel'];
        if (downloadResponse.HasError) {
          this.snackbarService.showInformation(downloadResponse.Message);
          this.fuseSplashScreenService.hide();
        } else {
          this.fileManagementService.downloadClientFileWithIdOneTimeSignedUrl(downloadResponse.fileId)
            .subscribe(payload => {
              this.fileManagementService.downloadOneTimeSignedUrl(payload.url, downloadResponse.fileName);
              this.fuseSplashScreenService.hide();
            });
        }
      }
    });
    return true;
  }

}
